import { withInstall } from '@ll-plus/utils'

import Breadcrumb from './src/breadcrumb.vue'

export const LlBreadcrumb = withInstall(Breadcrumb)
export default LlBreadcrumb

export * from './src/breadcrumb'

declare module 'vue' {
  export interface GlobalComponents {
    LlBreadcrumb: typeof Breadcrumb
  }
}
